import { useEffect, useState } from 'react';

export function useDynamicLottiePlayer() {
  const [LottiePlayer, setLottiePlayer] = useState<React.ComponentType<any> | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    import('@lottiefiles/react-lottie-player')
      .then((module) => {
        setLottiePlayer(() => module.Player);
      })
      .catch((err) => {
        console.error('Failed to load Lottie Player', err);
      });
  }, []);

  return LottiePlayer;
}
